import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

const DonutChart = ({ dataArray }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const ctx = chartRef.current.getContext("2d");

    const initializeChart = () => {
      const myChart = new Chart(ctx, {
        type: "doughnut",
        data: {
          labels: ["Intake", "No-Shows", "Patient Payments", "Staff Productivity"],
          datasets: [
            {
              label: "",
              data: dataArray,
              backgroundColor: ["#EEF156", "#5D9EDA", "#E14B80", "#FDAA6E"],
              hoverOffset: 5,
            },
          ],
        },
        options: {
          // layout: {
          //   padding: {
          //     bottom: 0, // Adjust this value to increase the gap between the legend and the chart
          //   },
          // },
          plugins: {
            legend: {
              labels: {
                usePointStyle: true,
                pointStyle: "circle",
                font: {
                  size: 16,
                },
                textAlign: "left",
              },
              position: "bottom",
              align: "left",
            },
            title: {
              display: true,
              text: "",
            },
            tooltip: {
              callbacks: {
                label: (context) => {
                  const value = context.formattedValue || "";
                  return "$" + value;
                },
              },
            },
          },
        },
      });
      return myChart;
    };

    const myChart = initializeChart();

    return () => {
      myChart.destroy();
    };
  }, [dataArray]);

  return (
    <div className="flex donut-chart-diagram">
      <canvas ref={chartRef} className="canvas-container"></canvas>
    </div>
  );
};

export default DonutChart;
